/**
 * strip multt-line text according to line limits
 * @param text
 * @param limits
 */
const stripMultipleLineText = (text, limits) => {
    if (!limits) {
        return text;
    }
    return text.split('\n').slice(0, limits).join('\n');
};
const stackReg = /(.*)@[^@]*\/([^?]*)(?:\?.*)?:(\d+):(\d+)/;
function transformStack(stack, simplifyStack) {
    if (!simplifyStack) {
        return stack;
    }
    return stack
        .split('\n')
        .map((line) => {
        const result = stackReg.exec(line);
        if (!result) {
            return line;
        }
        return `${result[1]}@${result[2]}:${result[3]}:${result[4]}`;
    })
        .join('\n');
}
/**
 * format error object for display/log
 * @param error error object
 * @param errLineLimits line limits for error message, 0 for no limits
 * @param stackLineLimits line limits for error stack, 0 for no limits
 * @param simplifyStack simplify the stack message for react-native error
 */
export function formatError(error, errLineLimits, stackLineLimits, simplifyStack) {
    const err = (error && error.toString()) || 'unknown';
    const stack = (error && error.stack) || '';
    return {
        msg: stripMultipleLineText(err, errLineLimits),
        stack: transformStack(stripMultipleLineText(stack, stackLineLimits), simplifyStack),
    };
}
